import * as XLSX from "xlsx";

// Archivo de pagos que manda el cliente (p. ej. "Prov_..._Pagos_....xls" de Control):
// columnas SUC | CONCEPTO | DESCRIPCION | FOLIO | IMPORTE | SALDO.
// IMPORTE positivo = pago a la factura; negativo = nota de cargo / descuento del cliente.

const redondea = (n) => Math.round((Number(n) || 0) * 100) / 100;

// "V-F141" -> { serie: "F", folio: 141 }; "V-F130MR" -> { serie: "F", folio: 130 }
export function parseFolioArchivo(texto) {
  const partes = String(texto || "").trim().toUpperCase().split("-");
  const ultimo = partes[partes.length - 1];
  const m = ultimo.match(/^([A-Z]*)(\d+)/);
  if (!m) return null;
  return { serie: m[1], folio: Number(m[2]) };
}

export function leerArchivoPagosCliente(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("No se pudo leer el archivo"));
    reader.onload = (e) => {
      try {
        const wb = XLSX.read(new Uint8Array(e.target.result), { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const filas = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true, defval: "" });
        const norm = (v) => String(v || "").trim().toUpperCase();
        const iHeader = filas.findIndex((f) => f.map(norm).includes("FOLIO") && f.map(norm).includes("IMPORTE"));
        if (iHeader < 0) throw new Error("No se encontraron las columnas FOLIO e IMPORTE");
        const h = filas[iHeader].map(norm);
        const col = (n) => h.indexOf(n);
        const renglones = [];
        filas.slice(iHeader + 1).forEach((f, idx) => {
          const folioArchivo = String(f[col("FOLIO")] || "").trim();
          const importe = f[col("IMPORTE")];
          // Se brinca el renglón de "IMPORTE TOTAL DEL PERIODO" y vacíos
          if (!folioArchivo || typeof importe !== "number" || !importe) return;
          const ref = parseFolioArchivo(folioArchivo);
          renglones.push({
            renglon: iHeader + idx + 2,
            concepto: String(f[col("CONCEPTO")] || "").trim(),
            descripcion: String(f[col("DESCRIPCION")] || "").replace(/^[.\s]+/, "").trim(),
            folioArchivo,
            serie: ref ? ref.serie : "",
            folio: ref ? ref.folio : null,
            importe: redondea(importe),
          });
        });
        resolve(renglones);
      } catch (err) {
        reject(err);
      }
    };
    reader.readAsArrayBuffer(file);
  });
}

// Junta los renglones del signo pedido (importe en positivo) por factura del sistema.
// facturas: [{ facturas: _id, serie, folio, saldo, ... }]
export function agruparPorFactura(renglones, facturas, signo) {
  const porFactura = {};
  const sinFactura = [];
  renglones
    .filter((r) => (signo > 0 ? r.importe > 0 : r.importe < 0))
    .forEach((r) => {
      const f = facturas.find(
        (x) => r.folio != null && Number(x.folio) === r.folio && (!r.serie || !x.serie || String(x.serie).toUpperCase() === r.serie)
      );
      if (!f) return sinFactura.push(r);
      if (!porFactura[f.facturas]) porFactura[f.facturas] = { factura: f, importe: 0, renglones: [] };
      porFactura[f.facturas].importe = redondea(porFactura[f.facturas].importe + Math.abs(r.importe));
      porFactura[f.facturas].renglones.push(r);
    });
  return { grupos: Object.values(porFactura), sinFactura };
}

export { redondea };
